export default __webpack_public_path__ + "static/media/Resume_Yarinbz.7fb2dcd6.pdf";